import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/header.css";
import logo from "../assets/logo.svg";

const Header = () => {
  const location = useLocation();

  return (
    <div className="header">
      <Link to="/" className="logo-link">
        <h2 className="logo-container">
          <img src={logo} alt="logo" className="logo" />
          <span style={{ width: "1rem" }}></span>
          <span style={{ color: "#CF4420" }}>H</span>okie{" "}
          <span style={{ color: "#630031" }}> H</span>elper
        </h2>
      </Link>
      <ul>
        <li className="mobile-hide">
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>
            Home
          </Link>
        </li>
        {/* <li>
          <Link
            to="/donate"
            className={location.pathname === "/donate" ? "active" : ""}
          >
            Donate
          </Lihw nk>
        </li> */}
        <li>
          <Link
            to="/search"
            className={location.pathname === "/search" ? "active" : ""}
          >
            Search
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Header;
